import React, { useState, useEffect } from 'react';
import API_URL from '../config.js';
import { authFetch } from '../auth';

const NewBarcodeView = ({ setView, fields = [] }) => {
  const [modalOpen, setModalOpen] = useState(true);
  const [busy, setBusy] = useState(false);
  const [values, setValues] = useState([]);
  const [labels, setLabels] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const used = (Array.isArray(fields) && fields.length) ? fields : ['File #', 'Buyer Name', 'Seller Name'];
    setLabels(used);
    setValues(Array(used.length).fill(''));
  }, [fields]);

  const onCancel = () => {
    setModalOpen(false);
    // Optionally navigate away
    if (setView) setView('all');
  };

  const onCreate = async () => {
    setError('');
    setBusy(true);
    try {
      // Open a placeholder window immediately to avoid popup blockers
      const win = window.open('', '_blank');
      const res = await authFetch(`${API_URL}/barcode/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ values }),
      });
      if (!res.ok) {
        const msg = (await res.json().catch(() => null))?.message || 'Create failed';
        // Close the placeholder window so a blank tab doesn't linger
        try { if (win && !win.closed) win.close(); } catch (_) {}
        throw new Error(msg);
      }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      if (win) {
        win.location = url;
        // Revoke after the new window loads the blob URL
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
      } else {
        // Fallback: open via programmatic link
        const a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
      }
    } catch (e) {
      setError(e.message || 'Failed to create barcode');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      {modalOpen && (
        <div style={modalOverlay}>
          <div style={modalDialog}>
            <h3 style={{ marginTop: 0, marginBottom: 12 }}>New Barcode</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {labels.map((lab, idx) => (
                <div style={row} key={idx}>
                  <label style={label}>{lab}</label>
                  <input style={input} value={values[idx] || ''} onChange={e => {
                    const next = [...values];
                    next[idx] = e.target.value;
                    setValues(next);
                  }} />
                </div>
              ))}
              {error && <div style={{ color: 'var(--danger)', fontSize: 13 }}>{error}</div>}
              <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                <button className="btn" onClick={onCreate} disabled={busy}>Create Barcode</button>
                <button className="btn-ghost" type="button" onClick={onCancel} disabled={busy}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {busy && (
        <div className="upload-spinner-overlay">
          <div className="upload-spinner-box">
            <div className="spinner-large"></div>
            <p>Creating barcode…</p>
          </div>
        </div>
      )}
    </div>
  );
};

const modalOverlay = {
  position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
  background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
};
const modalDialog = {
  width: '520px', maxWidth: '90vw', maxHeight: '90vh', overflowY: 'auto',
  background: 'var(--modal-bg)', borderRadius: 8, padding: 16, boxShadow: '0 10px 30px rgba(0,0,0,0.3)', color: 'var(--text)'
};
const row = { display: 'flex', flexDirection: 'column' };
const label = { fontSize: 12, color: 'var(--text)', marginBottom: 4 };
const input = {
  padding: '10px 12px',
  border: '1px solid var(--border-soft)',
  borderRadius: 6,
  background: 'var(--input-bg)',
  color: 'var(--text)',
  outline: 'none',
  boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.03)'
};

export default NewBarcodeView;
